import { Id } from "lib-shared/shared/models/types";
import { MyIsNotEmpty, MyMin } from "../../../modules/form-validation/decorators";

export class OrderQuantityForm {
  id : Id = null;

  @MyIsNotEmpty()
  @MyMin(1)
  min_order_quantity = 1;

  for_selected_products: Array<Id> = [];
  for_all_products: boolean = true;
}